
export const timer = {
    state:{
        formattedTimeLeft:''
    },
    mutations:{
        formattedTimeLeft(state){
            state.formattedTimeLeft = 'data'
            
        },
       
    },
    actions:{
        
        
      
     }
}